// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gHhT","icon":"styles_icon__1py69"};